import {
  LOAD_WATCHLIST,
  ADD_TO_WATCHLIST,
  UPDATE_WATCHLIST_ITEM,
  REMOVE_FROM_WATCHLIST,
  BULK_UPDATE_WATCHLIST,
} from "./types";
import { loadFromStorage, saveToStorage } from "../../storage";
import { computeShifts } from "./shiftLogic";

const persist = (getState) => {
  setTimeout(() => {
    saveToStorage("watchlist", getState().watchlist.items);
  }, 0);
};

export const loadWatchlist = () => (dispatch, getState) => {
  const items = loadFromStorage("watchlist");
  dispatch({ type: LOAD_WATCHLIST, payload: items });

  // Auto-shift overdue items
  const shifts = computeShifts(items);
  if (shifts.length > 0) {
    const updates = {};
    shifts.forEach((item) => {
      updates[item.imdbID] = item;
    });
    dispatch({ type: BULK_UPDATE_WATCHLIST, payload: updates });
    persist(getState);
  }
};

export const addToWatchlist = (movie, date, time) => (dispatch, getState) => {
  const data = {
    imdbID: movie.imdbID,
    Title: movie.Title,
    Year: movie.Year,
    Poster: movie.Poster,
    Type: movie.Type,
    scheduledDate: date,
    scheduledTime: time,
    status: "planned",
    shiftCount: 0,
    addedAt: Date.now(),
  };
  dispatch({ type: ADD_TO_WATCHLIST, payload: data });
  persist(getState);
};

export const markWatched = (imdbID) => (dispatch, getState) => {
  const item = getState().watchlist.items[imdbID];
  if (!item) return;
  const updated = { ...item, status: "watched" };
  dispatch({ type: UPDATE_WATCHLIST_ITEM, payload: updated });
  persist(getState);
};

export const removeFromWatchlist = (imdbID) => (dispatch, getState) => {
  dispatch({ type: REMOVE_FROM_WATCHLIST, payload: imdbID });
  persist(getState);
};

export const processShifts = () => (dispatch, getState) => {
  const { items } = getState().watchlist;
  const shifts = computeShifts(items);
  if (shifts.length === 0) return;

  const updates = {};
  shifts.forEach((item) => {
    updates[item.imdbID] = item;
  });
  dispatch({ type: BULK_UPDATE_WATCHLIST, payload: updates });
  persist(getState);
};
